import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import Button from "../../../../components/ui/Button/Button";
import "./ServicesHero.css";

const ServicesHero = () => {
  const heroRef = useRef(null);
  const badgeRef = useRef(null);
  const headlineRef = useRef(null);
  const descriptionRef = useRef(null);
  const ctaRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ delay: 0.2 });

      tl.from(badgeRef.current, {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: "power3.out",
      })
        .from(
          headlineRef.current,
          {
            opacity: 0,
            y: 40,
            duration: 1,
            ease: "power3.out",
          },
          "-=0.5",
        )
        .from(
          descriptionRef.current,
          {
            opacity: 0,
            y: 30,
            duration: 0.8,
            ease: "power3.out",
          },
          "-=0.6",
        )
        .from(
          ctaRef.current,
          {
            opacity: 0,
            y: 20,
            duration: 0.8,
            ease: "power3.out",
          },
          "-=0.5",
        );
    }, heroRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="services-hero" ref={heroRef}>
      <div className="services-hero__container">
        <div className="services-hero__badge" ref={badgeRef}>
          OUR SERVICES
        </div>
        <h1 className="services-hero__headline" ref={headlineRef}>
          Everything You Need to{" "}
          <span className="services-hero__highlight">Grow Your Clinic</span>
        </h1>
        <p className="services-hero__description" ref={descriptionRef}>
          From lead generation to automated patient journeys, We don’t outsource
          calls to generic sales reps. We qualify properly. We set expectations.
          We protect your calendar. Our system is designed exclusively for
          aesthetic clinics. No guesswork. No wasted ad spend. Just predictable,
          scalable growth.
        </p>
        <div className="services-hero__cta" ref={ctaRef}>
          <Button
            text="Book a Strategy Call"
            variant="primary"
            link="/contact"
          />
          <Button
            text="See How It Works"
            variant="secondary"
            link="/how-it-works"
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
